import { useQuery } from '@apollo/react-hooks';
import ENROLLMENT_DATA_QUERY from '../graphql/getEnrollmentData.graphql';

type GraphqlData = {
  course: {
    originalId: number;
    title: string;
    canEnroll: boolean;
    isEnrollment: boolean;
  };
};

type GraphqlVariables = {
  id: number;
};

const useEnrollmentData = course => {
  const { loading, data } = useQuery<GraphqlData, GraphqlVariables>(
    ENROLLMENT_DATA_QUERY,
    {
      variables: {
        id: course.originalId,
      },
    },
  );

  if (loading) {
    return {
      loading,
      canEnroll: false,
      isEnrollment: false,
    };
  }

  return {
    loading,
    canEnroll: data?.course.canEnroll,
    isEnrollment: data?.course.isEnrollment,
  };
};

export default useEnrollmentData;
